import { Theme } from '@radix-ui/themes'

import React from 'react'
import Modal from 'react-modal'
import { Checkbox, Flex, Text } from 'components/ds'
import Button from 'components/ui/button'
import ButtonContainer from 'components/ui/button-container'
import modalStyles from 'components/utils/modalStyles'
export type Props = {
  onConfirm: (...args: Array<any>) => any
  onCancel: (...args: Array<any>) => any
  onHideWarningChange: (...args: Array<any>) => any
  hideWarning: boolean
  trackCount: number
}

const MergeConfirmationDialog = (props: Props): React.ReactNode => {
  const { onConfirm, onCancel, hideWarning, onHideWarningChange, trackCount } =
    props
  return (
    <Modal style={modalStyles} isOpen onRequestClose={onCancel}>
      <Theme>
        <div className="Dialog">
          <div>
            <p>
              Good news! You&#39;re about to merge {trackCount} tracks. The
              master track you&#39;ve chosen will be kept, and the other tracks
              will be deleted.
            </p>
            <p>
              If you&#39;d like to keep any metadata from the non-master tracks,
              click Cancel below and add the metadata to the relevant fields,
              and then click <b>Merge tracks</b>.
            </p>
          </div>
          <Flex gap="2" align="center" justify="between">
            <Text as="label" size="2">
              <Flex gap="2">
                <Checkbox
                  defaultChecked={hideWarning}
                  onCheckedChange={onHideWarningChange}
                />
                Don&#39;t show this warning again
              </Flex>
            </Text>
            <ButtonContainer>
              <Button caption="Cancel" onClick={onCancel} />
              <Button
                caption="Let’s merge"
                onClick={onConfirm}
                appearance="primary"
              />
            </ButtonContainer>
          </Flex>
        </div>
      </Theme>
    </Modal>
  )
}

export default MergeConfirmationDialog
